import React from 'react'
import CollectionOrderFormPageContainer from './CollectionOrderFormPageContainer';

export class CollectionOrderFormPage extends React.Component{
    render(){
        return (
            <CollectionOrderFormPageContainer { ...this.props } />
        )
    }
}